import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [51.501396, -0.126109, 17.2],
  [51.501594, -0.12611, 17.6],
  [51.501782, -0.12612, 18],
  [51.501975, -0.126124, 18.2],
  [51.502168, -0.126126, 18.4],
  [51.502361, -0.126128, 18.4],
  [51.502554, -0.126131, 18.2],
  [51.502753, -0.126135, 18.2],
  [51.502941, -0.126139, 18.2],
  [51.503145, -0.126146, 18],
  [51.503343, -0.126171, 17.8],
  [51.503536, -0.1262, 17.4],
  [51.50374, -0.126233, 16.8],
  [51.503944, -0.126273, 16.6],
  [51.504142, -0.12632, 16.8],
  [51.504341, -0.126373, 17.6],
  [51.504534, -0.126432, 18.8],
  [51.504716, -0.12649, 20],
  [51.504904, -0.126557, 21.4],
  [51.505081, -0.126626, 22.4],
  [51.50529, -0.126716, 23.6],
  [51.50543, -0.126779, 24.4],
  [51.505607, -0.126863, 25.4],
  [51.505773, -0.126951, 26],
  [51.505945, -0.127039, 26.2],
  [51.506116, -0.127124, 26.2],
  [51.506293, -0.127219, 26],
  [51.50647, -0.127316, 25.8],
  [51.506653, -0.12741, 25.8],
];

export default stream;
